/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Checkbox,
  Button,
  Input,
  InputNumber,
  message,
  Form,
  Spin,
} from 'antd';
import { useTranslation } from 'react-i18next';
import RSelect from 'react-select';
import { useHistory } from 'react-router-dom';
import get from 'lodash/get';
import anchorme from 'anchorme';
import { getWeboConfig, isProductHasAgreement } from '../../utils';
import {
  reserveProductToUserAction,
  isUserDeservedForGiftAction,
} from '../../data/modules/products/products.actions';
import { FlexDivCenter, Text } from '../../components/Typography/Typography';
import 'moment/locale/he';
import UseMedia from '../../customHooks/UseMedia';

export default ({ activeProduct = {}, setIsFinished }) => {
  const [form] = Form.useForm();
  const [isInAriel, setIsInAriel] = useState();
  const [pickGiftFrom, setPickGiftFrom] = useState();
  const [loading, setLoading] = useState();
  const [deservedForTheProduct, setDeservedForTheProduct] = useState(true);
  const [checked, setChecked] = useState(!isProductHasAgreement(activeProduct));
  const { isMobile } = UseMedia();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { activeUser } = useSelector((state) => state.auth);

  function renderPhysicalGiftQuestions() {
    return (
      <div style={{ zIndex: 999999 }}>
        <Form.Item
          label={t('pick')}
          name="pick"
          rules={[
            {
              required: true,
              message: t('required', { field: t('pick') }),
            },
          ]}
        >
          <RSelect
            onChange={({ value }) => setPickGiftFrom(value)}
            placeholder="בחר"
            options={[
              { value: 'ariel', label: t('ariel') },
              { value: 'shipping', label: t('shipping') },
            ]}
          />
        </Form.Item>
        {pickGiftFrom === 'shipping' && (
          <>
            <Form.Item
              label={t('city')}
              name="city"
              rules={[
                {
                  required: true,
                  message: t('required', { field: t('city') }),
                },
              ]}
            >
              <Input placeholder={t('city')} />
            </Form.Item>

            <Form.Item
              label={t('street')}
              name="street"
              rules={[
                {
                  required: true,
                  message: t('required', { field: t('street') }),
                },
              ]}
            >
              <Input placeholder={t('street')} />
            </Form.Item>
            <Form.Item
              label={t('home_number')}
              name="home_number"
              rules={[
                {
                  required: true,
                  message: t('required', { field: t('home_number') }),
                },
              ]}
            >
              <Input placeholder={t('home_number')} />
            </Form.Item>

            <Form.Item
              label={t('apartment_number')}
              name="apartment_number"
              rules={[
                {
                  required: true,
                  message: t('required', { field: t('apartment_number') }),
                },
              ]}
            >
              <Input placeholder={t('apartment_number')} />
            </Form.Item>

            <Form.Item label={t('entrance_number')} name="entrance_number">
              <Input placeholder={t('entrance_number')} />
            </Form.Item>

            <Form.Item label={t('floor')} name="floor">
              <Input placeholder={t('floor')} />
            </Form.Item>

            <Form.Item label={t('postal_code')} name="postal_code">
              <Input placeholder={t('postal_code')} />
            </Form.Item>

            <Form.Item label={t('another_number')} name="another_number">
              <Input placeholder={t('another_number')} />
            </Form.Item>

            <Form.Item label={t('notes')} name="notes">
              <Input.TextArea placeholder={t('notes')} />
            </Form.Item>
          </>
        )}
      </div>
    );
  }

  useEffect(() => {
    setLoading(true);
    dispatch(isUserDeservedForGiftAction())
      .then((res) => {
        setDeservedForTheProduct(!res.gotAGift);
        setLoading(false);
      })
      .catch(() => {
        setDeservedForTheProduct(false);
        setLoading(false);
      });
  }, []);

  function isButtonDisabled() {
    return !checked || !deservedForTheProduct || loading;
  }

  function onReserveProduct() {
    form.validateFields().then((values) => {
      setLoading(true);
      const cloned = { ...values };
      if (cloned.pick) {
        cloned.pick = cloned.pick.value;
      }
      // if (cloned.apartment) cloned.apartment = values.apartment.value;
      // cloned.statusInCovid = cloned.statusInCovid.value;
      // cloned.stayInAriel = cloned.stayInAriel.value;
      // cloned.usedAgudaServices = cloned.usedAgudaServices.value;
      dispatch(
        reserveProductToUserAction({
          productId: activeProduct.id,
          userId: activeUser.id,
          answers: cloned,
        })
      )
        .then((res) => {
          setLoading(false);
          setIsFinished(true);
          message.success({
            content: t('assign_product_success'),
            style: {
              marginTop: '10vh',
              fontSize: 16,
            },
          });
        })
        .catch((err) => {
          message.error(
            'שריון המוצר נכשל - לתמיכה יש ליצור קשר עם גורמי האגודה'
          );
          history.push('/');
        });
    });
  }

  return loading ? (
    <FlexDivCenter>
      <Spin />{' '}
    </FlexDivCenter>
  ) : !deservedForTheProduct ? (
    <Text
      bold
      style={{ maxWidth: 400 }}
      dangerouslySetInnerHTML={{
        __html: t('not_deserved', {
          store_support: getWeboConfig('STORE_SUPPORT_EMAIL'),
        }),
      }}
    />
  ) : (
    <Form
      style={{ marginTop: 30 }}
      form={form}
      name="normal_login"
      className="login-form"
      initialValues={{ remember: true }}
      onFinish={onReserveProduct}
      onFinishFailed={() => {
        message.error(t('missing_fields'));
      }}
    >
      <Form.Item
        label={t('phone_number')}
        name="phoneNumber"
        rules={[
          {
            required: true,
            message: t('required', { field: t('phone_number') }),
          },
        ]}
      >
        <Input maxLength="10" placeholder="0503673552" />
      </Form.Item>
      <Form.Item
        label={t('city')}
        name="city"
        rules={[
          { required: true, message: t('required', { field: t('city') }) },
        ]}
      >
        <Input maxLength="10" placeholder="אשקלון" />
      </Form.Item>
      {/* <Form.Item
        label={t('will_you_stay_in_ariel')}
        name="stayInAriel"
        rules={[
          {
            required: true,
            message: t('required', { field: t('will_you_stay_in_ariel') }),
          },
        ]}
      >
        <RSelect
          onChange={({ value }) => setIsInAriel(value)}
          placeholder="בחר"
          options={[
            { value: t('yes'), label: t('yes') },
            { value: t('no'), label: t('no') },
          ]}
        />
      </Form.Item> */}
      {/* {isInAriel === 'כן' && (
        <Form.Item
          label={t('which_apartment')}
          name="apartment"
          rules={[
            {
              required: true,
              message: t('required', { field: t('which_apartment') }),
            },
          ]}
        >
          <RSelect
            placeholder="בחר"
            options={[
              { value: t('apartment'), label: t('apartment') },
              { value: t('dorms'), label: t('dorms') },
            ]}
          />
        </Form.Item>
      )} */}
      {/* <Form.Item
        label={t('have_you_used')}
        name="usedAgudaServices"
        rules={[
          {
            required: true,
            message: t('required', { field: t('have_you_used') }),
          },
        ]}
      >
        <RSelect
          placeholder="בחר"
          options={[
            { value: t('yes'), label: t('yes') },
            { value: t('no'), label: t('no') },
          ]}
        />
      </Form.Item> */}
      {/* <Form.Item
        label={t('what_was_your_status_in_covid')}
        name="statusInCovid"
        rules={[
          {
            required: true,
            message: t('required', {
              field: t('what_was_your_status_in_covid'),
            }),
          },
        ]}
      >
        <RSelect
          placeholder="בחר"
          options={[
            { value: 'unpaid_vacation', label: t('unpaid_vacation') },
            { value: 'employment', label: t('employment') },
            { value: 'working', label: t('working') },
            { value: 'not_working', label: t('not_working') },
          ]}
        />
      </Form.Item> */}
      {/* <Form.Item
        label={t('year_of_study')}
        name="yearOfStudy"
        rules={[
          {
            required: true,
            message: t('required', { field: t('year_of_study') }),
          },
        ]}
      >
        <InputNumber max={7} min={1} placeholder="2" />
      </Form.Item> */}
      {/* {!activeProduct.usePromo && renderPhysicalGiftQuestions()} */}
      <div style={{ height: 100 }} />
      <FlexDivCenter style={{ maxWidth: 350 }}>
        <Text
          align="right"
          size="small"
          dangerouslySetInnerHTML={{
            __html: anchorme({
              input: activeProduct?.agreement?.replace('\n', '<br/>') || '',
              options: {
                // any link will have the attribute "class='link'"
                // and will be downloaded
                attributes(string) {
                  const attributes = {
                    target: '_blank',
                  };
                  return attributes;
                },
              },
            }),
          }}
        />
      </FlexDivCenter>
      {isProductHasAgreement(activeProduct) && (
        <Form.Item name="is_accepted">
          <Checkbox
            onChange={(e) => setChecked(e.target.checked)}
            style={{ fontSize: 20 }}
            max={7}
            min={1}
            placeholder="2"
          >
            {t('i_have_read')}
          </Checkbox>
        </Form.Item>
      )}
      <FlexDivCenter>
        <Form.Item>
          <Button
            htmlType="submit"
            disabled={isButtonDisabled()}
            style={{
              margin: 15,
              color: isButtonDisabled() ? '' : 'white',
              width: 150,
              background: isButtonDisabled() ? '' : '#1D3E7E',
            }}
            loading={loading}
            type="primary"
          >
            {t('reserve')}
          </Button>
        </Form.Item>
      </FlexDivCenter>
    </Form>
  );
};
